import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Commands } from '../../services/commands/commands';

export const playerConnectionGuard: CanActivateFn = (route, state) => {

  const commands = inject(Commands);
  const router = inject(Router);

  const room_id = route.paramMap.get('room_id');

  return commands.getClientId()
    ? true
    : router.createUrlTree([`${route.url[0]?.path}/waiting-room/${room_id}`]);

};
